import axios from 'axios'
import { generateAuthHeader, clearAuthentication } from '@/utils/authHelp'
import { loadingActions } from '@/redux/actions/loadingActions'
import store from '@/redux'
import { modalError } from '@/utils/modalUtils'
import { redirectURL } from '@/utils/authHelp'
import { formatMessage } from '@/utils/common'
let requstCounts = 0
let errorCount = 0
const instance = axios.create({
  // baseURL: process.env.REACT_APP_API_URL
  // timeout: 5000
})

// const whiteListReg = RegExp('/batches/[a-zA-Z0-9]{32}$')
// Add a request interceptor
instance.interceptors.request.use(
  async function(config) {
    // Do something before request is sent
    // Don't show Spin when searching split status
    // if (!(config.method === 'get' && whiteListReg.test(config.url))) {
    if (!config['noSpin']) {
      store.dispatch(loadingActions(true)) // show Spin Loading
      requstCounts++
    }
    const authHeaders = await generateAuthHeader()
    config.headers = {
      ...config.headers,
      ...authHeaders
    }
    // 解决IE中网络请求相同url会从缓存中读取的问题，为每个请求增加一个_t参数
    config.headers['Cache-Control'] = 'no-cache'
    config.params = {
      ...config.params,
      _t: new Date().getTime()
    }
    return config
  },
  function(error) {
    // Do something with request error
    requstCounts = requstCounts - 1 < 0 ? 0 : requstCounts - 1
    requstCounts === 0 && store.dispatch(loadingActions(false))
    return Promise.reject(error)
  }
)

// Add a response interceptor
instance.interceptors.response.use(
  function(response) {
    // Do something with response data
    // if(response.config.method !== 'get'){
    requstCounts = requstCounts - 1 < 0 ? 0 : requstCounts - 1
    requstCounts === 0 && store.dispatch(loadingActions(false))
    // }
    const { config, data } = response
    const {
      errorcode
      // errormessage
    } = data || {}
    if (errorcode) {
      if (errorcode === '200') {
        return response.data
      } else if (errorcode === '401') {
        errorFun('languageObj.httpLocale.tokenInvalid', () => {
          clearAuthentication()
          window.location.href = redirectURL
        })
        return Promise.reject(response)
      } else if (errorcode === '410') {
        errorFun('languageObj.httpLocale.loginNameExists')
        return Promise.reject(response)
      } else if (errorcode === '411') {
        errorFun('languageObj.httpLocale.accountExpired')
        return Promise.reject(response)
      } else if (errorcode === '413') {
        errorFun('languageObj.httpLocale.codeInvalid')
        return Promise.reject(response)
      } else if (errorcode === '414') {
        errorFun('languageObj.httpLocale.oktaError', () => {
          clearAuthentication()
          window.location.href = redirectURL
        })

        return Promise.reject(response)
      } else {
        if (!config.hiddenError) {
          // logistic error
          errorFun('languageObj.httpLocale.requestError')
        }
        return Promise.reject(response.data)
      }
    } else {
      if (config.uploadOrDownload) {
        return response
      }
      return Promise.reject(response)
    }
  },
  function(error) {
    // Do something with response error
    requstCounts = requstCounts - 1 < 0 ? 0 : requstCounts - 1
    requstCounts === 0 && store.dispatch(loadingActions(false))
    const { response } = error
    if (response) {
      switch (response.status) {
        case 401:
        case '401':
          errorFun('languageObj.httpLocale.tokenInvalid', () => {
            clearAuthentication()
            window.location.href = redirectURL
          })
          break
        case 404:
        case '404':
          errorFun('languageObj.httpLocale.code404')
          break
        case 504:
        case '504':
          errorFun('languageObj.httpLocale.timeOut')
          break
        case 500:
        case '500':
          errorFun('languageObj.httpLocale.systemError')
          break
        default:
          errorFun('languageObj.httpLocale.requestError')
          break
      }
    } else {
      errorFun('languageObj.httpLocale.requestError')
    }

    return Promise.reject(error)
  }
)
const errorFun = (title, cb) => {
  if (errorCount > 0) {
  } else {
    errorCount++
    modalError({ content: formatMessage(title) }, () => {
      errorCount = 0
      cb && cb()
    })
  }
}
export default instance
